import FullPageLoader from '@src/common/FullPageLoader';
import React, { useState,useRef,useEffect } from 'react';
import Modal from "../../common/ModalPopup";
import {saveRemittancePayment,assignLead} from '../../../src/store/slices/remittance';
import { useParams } from "react-router-dom";
import ReactSelect from "react-select";
import {LEAD_REMITTANCE_STATUS_MARK,LEAD_ASSIGN_TO} from '../../config/constant'
import { useLanguage } from "../../../src/context/LanguageContext";
import { allowAlphaNumericKeys } from '@src/config/helper';


const LeadAssigneePopup: React.FC<any> = (props:any) => {
    const {translations} = useLanguage();
    const [formData, setFormData] = useState<any>({});
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [formErrors, setFormErrors] = useState<any>({});
    const [collectionAgentId, setCollectionAgentId] = useState<number>(0);

    const handleAgentChange = (value: number) => {
        setCollectionAgentId(value);
    }

    const validateForm = (): boolean => {
        let errors: any = {};
        if(!collectionAgentId){
            errors.member = "Please select agent to assign lead";
        }
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    }

    const handleAssign = () => {
        let isFormValid = validateForm();
        if(isFormValid){
            props.setAgentId(collectionAgentId);
            props.setShowLeadAssignPopup(false)
            props.setShowConfirmation(true);
        }
    }

    return (
        <div className="view-timeline-popup image-timeline-popup">
            <Modal show={props.showLeadAssignPopup} handleClose={() => props.setShowLeadAssignPopup(false)} from={props.from}>
                <div className="modal-header">
                    <h2>{props.message || "Assign Leads"}</h2>
                </div>
                <div className="modal-body lead_assign-body-popup">
                    <div className="row">
                        <div className="col-md-12">
                                <ReactSelect
                                    options={props.assignUsers}
                                    onChange={(e: any) => handleAgentChange(e.value)}
                                    value={props.assignUsers.find((x: any) => +x.value === collectionAgentId)}
                                    placeholder={props.userRoleLabel ? props.userRoleLabel  : "Collection Agents"}
                                />
                                {formErrors.member && (
                                    <small className="error">{formErrors.member}</small>
                                )}
                            <br></br>
                        </div>
                
                       <div className="col-md-12">
                            <button className="btn btn-primary btn-lg m-sm-r" style={{ minWidth: "107px" }} onClick={() => handleAssign()}>Assign</button>
                            <button className="btn btn-line" onClick={() => props.setShowLeadAssignPopup(false)}>Cancel</button>
                         </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default LeadAssigneePopup;